import { LOTTIE_VISUAL } from '../elements/lottie'
import { ASSET_DESKTOP } from '../elements/assets'
import { ASSET_MOBILE } from '../elements/assets'
import { BUTTON, BUTTON_SETTINGS } from '../elements/link'

export const TEXT_AND_MEDIA_DELIGHT = `
...on textAndMediaDelight_Entry {
  ${ LOTTIE_VISUAL }
  id
  typeHandle
  anchorId

  backgroundColor
  position

  heading {
    html
  }
  description
  headAlignMobile
  headAlignDesktop

  textContentPosition

  table {
    id
    label
    title: value
    description
  }

  ${ ASSET_DESKTOP }
  ${ ASSET_MOBILE }

  conversationBox {
    ... on conversationBox_Entry {
      id
      html
    }
  }

  extendWithTips
  tipsBackground

  tipHeading1
  tipIcon1 {url}
  tipDescription1
  tipHeading2
  tipIcon2 {url}
  tipDescription2
  tipHeading3
  tipIcon3 {url}
  tipDescription3
  tipHeading4
  tipIcon4 {url}
  tipDescription4

  ${ BUTTON }
  ${ BUTTON_SETTINGS }
}
`
